import PersonalDetails from "./personal-details"
import JobDetails from "./job-details"

export const Info = () => { }
Info.PersonalDetails = ( props ) => PersonalDetails( props )
Info.JobDetails = ( props ) => JobDetails( props )

export default Info